export default {
  computed: {
    content() {
      return this.$store.getters["system/content"][this.$options.name];
    },
  },
};